import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 4rem;
  align-items: center;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.grayDark4};
  font-family: ${({ theme }) => theme.fonts.workSans};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    gap: 0.5rem;
    flex-direction: column;
  }

  input {
    width: 10.75rem;
  }

  .inputTime {
    display: none;
  }
`;

export const ContainerTooltip = styled.div``;
